import v from './polyfills';
v();

import './style/index.scss';
import App from './components/app';

export default App;
